export default "__VITE_ASSET__df29205c__"